module.exports = __webpack_public_path__ + "media/dashboard/assets/images/banners/octopus-computer-b8326fc92f9c6ef1bce2f5f5938c4746.png";